<template>
    <span class="embed-audio w-full">
        <audio controls="controls" preload="auto" class="w-full">
            <source :src="`${audioSrc}`" type="audio/mpeg">
            Sorry, your browser does not support the audio tag.
        </audio>
    </span>
</template>

<script>
export default {
    name: 'EmbedAudio',
    props: {
        audioSrc: {
            type: String,
            required: true
        }
    },
};

</script>
